// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Contravariant_Compat from "../Data.Functor.Contravariant.Compat/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Raven from "../Raven/index.js";
import * as Restaumatic_Accounts_Types_Id from "../Restaumatic.Accounts.Types.Id/index.js";
import * as Restaumatic_Countries from "../Restaumatic.Countries/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Restaumatic_Restaurants_Types_DeliveryInfo from "../Restaumatic.Restaurants.Types.DeliveryInfo/index.js";
import * as Restaumatic_Services_Delivery_Backend from "../Restaumatic.Services.Delivery.Backend/index.js";
import * as Restaumatic_Services_Geocoding_Default from "../Restaumatic.Services.Geocoding.Default/index.js";
import * as Restaumatic_Services_Storage_LocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Restaumatic_Site_Components_DeliveryAddress from "../Restaumatic.Site.Components.DeliveryAddress/index.js";
import * as Restaumatic_Site_I18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic_Sites_RestaurantSelection_Types_Restaurant from "../Restaumatic.Sites.RestaurantSelection.Types.Restaurant/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Extra from "../Specular.Dom.Extra/index.js";
import * as Specular_FRP_Async from "../Specular.FRP.Async/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Utils_DOM from "../Utils.DOM/index.js";
import * as Web_DOM_Element from "../Web.DOM.Element/index.js";
import * as Web_DOM_NodeList from "../Web.DOM.NodeList/index.js";
import * as Web_DOM_ParentNode from "../Web.DOM.ParentNode/index.js";
import * as Web_Event_Event from "../Web.Event.Event/index.js";
import * as Web_Event_EventTarget from "../Web.Event.EventTarget/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_Location from "../Web.HTML.Location/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var decode = /* #__PURE__ */ Foreign_Generic_Class.decode(Restaumatic_Accounts_Types_Id.decodeAccountId);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var decode1 = /* #__PURE__ */ Foreign_Generic_Class.decode(Restaumatic_Countries.decodeCountry);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var discard2 = /* #__PURE__ */ discard(Specular_Dom_Builder.bindBuilder);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Specular_Dom_Builder.monadEffectBuilder);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Specular_Dom_Builder.monadEffectBuilder);
var newRef = /* #__PURE__ */ Specular_Ref.newRef(Specular_Dom_Builder.monadEffectBuilder);
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var attachEvent = /* #__PURE__ */ Specular_Callback.attachEvent()(monadFRP);
var refUpdateConst = /* #__PURE__ */ Specular_Ref.refUpdateConst(Effect_Class.monadEffectEffect);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var asyncRequestMaybe = /* #__PURE__ */ Specular_FRP_Async.asyncRequestMaybe(Specular_Dom_Builder.monadEffectBuilder)(monadFRP);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(monadFRP);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Effect.functorEffect);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect);
var for_1 = /* #__PURE__ */ for_(Data_Foldable.foldableArray);
var triggerCallback = /* #__PURE__ */ Specular_Callback.triggerCallback();
var for_2 = /* #__PURE__ */ for_(Data_Foldable.foldableMaybe);
var show1 = /* #__PURE__ */ Data_Show.show(Restaumatic_Restaurant_Types_Id.showRestaurantId);
var getField = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Sites_RestaurantSelection_Types_Restaurant.hasFieldRestaurant(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "id";
    }
})()));
var getField1 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Sites_RestaurantSelection_Types_Restaurant.hasFieldRestaurant(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "deliveryInfo";
    }
})()));
var getField2 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Restaurants_Types_DeliveryInfo.hasFieldDeliveryInfo(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "deliveryCost";
    }
})()));
var getField3 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Restaurants_Types_DeliveryInfo.hasFieldDeliveryInfo(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "minOrderValue";
    }
})()));
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Effect.bindEffect);
var getField4 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Sites_RestaurantSelection_Types_Restaurant.hasFieldRestaurant(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "slug";
    }
})()));
var getField5 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Restaurants_Types_DeliveryInfo.hasFieldDeliveryInfo(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "freeDeliveryThreshold";
    }
})()));
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveInt);
var UNKNOWN = /* #__PURE__ */ (function () {
    function UNKNOWN() {

    };
    UNKNOWN.value = new UNKNOWN();
    return UNKNOWN;
})();
var OK = /* #__PURE__ */ (function () {
    function OK() {

    };
    OK.value = new OK();
    return OK;
})();
var OTHER = /* #__PURE__ */ (function () {
    function OTHER() {

    };
    OTHER.value = new OTHER();
    return OTHER;
})();
var parseAccountId = function (v) {
    return Control_Monad_Except.runExcept(bind(decode(v))(function (v1) {
        return pure(v1);
    }));
};
var init = function (v) {
    var country = (function () {
        var v1 = Control_Monad_Except.runExcept(decode1(encode(v.country)));
        if (v1 instanceof Data_Either.Right) {
            return v1.value0;
        };
        if (v1 instanceof Data_Either.Left) {
            Raven.captureMessage("DeliveryForm: Invalid country")({
                country: show(v.country)
            })();
            return Restaumatic_Countries.PL.value;
        };
        throw new Error("Failed pattern match at Components.DeliveryForm (line 42, column 5 - line 46, column 26): " + [ v1.constructor.name ]);
    })();
    var form = Utils_DOM.querySelectorOrThrow("form")(v.element)();
    var formPlaceholder = Utils_DOM.querySelectorOrThrow(".js-delivery-form-placeholder")(form)();
    var addressEnv = {
        forceShowValidationErrors: pure2(false),
        geocoding: Restaumatic_Services_Geocoding_Default.defaultJSGeocoding(new Data_Maybe.Just(v.accountId))(Data_Maybe.Nothing.value),
        storage: Restaumatic_Services_Storage_LocalStorageWithFallback.localStorageWithFallback
    };
    var addressConfig = {
        country: country,
        accountId: v.accountId,
        restaurantId: Data_Maybe.Nothing.value,
        withAptInfo: false,
        geocodingAddressE: Specular_FRP_Base.never
    };
    Specular_Dom_Extra.runWidgetInDomNode(Web_DOM_Element.toNode(formPlaceholder))(bind2(Specular_Dom_Builder.local(function (v1) {
        return addressEnv;
    })(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("m-delivery-address__container") ])(Restaumatic_Site_Components_DeliveryAddress.deliveryAddressWidget(addressConfig))))(function (v1) {
        return discard2(Restaumatic_Site_Components_DeliveryAddress.geocodingStatus(false)(v1.status))(function () {
            return bind2(newEvent)(function (submit) {
                return bind2(readDynamic(v1.address))(function (initialAddress) {
                    return bind2(newRef(Data_Maybe.isJust(initialAddress)))(function (shouldSubmit) {
                        return discard2(attachEvent(submit.event)(Data_Functor_Contravariant_Compat.cvoidRight(true)(refUpdateConst(shouldSubmit))))(function () {
                            return bind2(liftEffect(Web_Event_EventTarget.eventListener(function (ev) {
                                return function __do() {
                                    Web_Event_Event.preventDefault(ev)();
                                    return submit.fire(Data_Unit.unit)();
                                };
                            })))(function (listener) {
                                return discard2(liftEffect(Utils_DOM["addEventListener$prime"]("submit")(listener)(form)))(function () {
                                    var toCoordinates = function ($130) {
                                        return wrap((function (v2) {
                                            return {
                                                lon: v2.longitude,
                                                lat: v2.latitude
                                            };
                                        })((function (v2) {
                                            return v2.location;
                                        })(unwrap($130))));
                                    };
                                    var action = (function () {
                                        var $131 = Restaumatic_Services_Delivery_Backend.deliveringRestaurants(v.siteId);
                                        var $132 = map(toCoordinates);
                                        return function ($133) {
                                            return $131($132($133));
                                        };
                                    })();
                                    var actionIf = function (v2) {
                                        return function (v3) {
                                            if (v2) {
                                                return new Data_Maybe.Just(action(v3));
                                            };
                                            if (!v2) {
                                                return Data_Maybe.Nothing.value;
                                            };
                                            throw new Error("Failed pattern match at Components.DeliveryForm (line 87, column 7 - line 87, column 40): " + [ v2.constructor.name, v3.constructor.name ]);
                                        };
                                    };
                                    return bind2(asyncRequestMaybe(apply(map1(actionIf)(Specular_Ref.refValue(shouldSubmit)))(v1.address)))(function (deliveringRestaurantsResult) {
                                        return Data_Function.flip(subscribeDyn_)(apply(map1(Data_Tuple.Tuple.create)(v1.address))(deliveringRestaurantsResult))(function (result) {
                                            return function __do() {
                                                var allResults = Web_DOM_ParentNode.querySelectorAll(wrap(".js-delivery-details--ok, .js-delivery-details--error"))(Web_DOM_Element.toParentNode(v.element))();
                                                var nodes = mapFlipped(Web_DOM_NodeList.toArray(allResults))((function () {
                                                    var $134 = map2(Web_DOM_Element.fromNode);
                                                    return function ($135) {
                                                        return Data_Array.catMaybes($134($135));
                                                    };
                                                })())();
                                                for_1(nodes)(Utils_DOM.hide)();
                                                if (result.value0 instanceof Data_Maybe.Just && (result.value1 instanceof Specular_FRP_Async.Loaded && (result.value1.value0 instanceof Data_Either.Right && result.value1.value0.value0.length === 0))) {
                                                    triggerCallback(refUpdateConst(shouldSubmit))(false)();
                                                    var errors = Utils_DOM["querySelector$prime"](".js-delivery-details--error")(v.element)();
                                                    return for_2(errors)(Utils_DOM.show)();
                                                };
                                                if (result.value0 instanceof Data_Maybe.Just && (result.value1 instanceof Specular_FRP_Async.Loaded && result.value1.value0 instanceof Data_Either.Right)) {
                                                    triggerCallback(refUpdateConst(shouldSubmit))(false)();
                                                    var v2 = Data_Array.head(result.value1.value0.value0);
                                                    if (v2 instanceof Data_Maybe.Just) {
                                                        var itemDiv = Utils_DOM["querySelector$prime"](".js-delivery-details--ok[data-restaurant=\"" + (show1(getField(Type_Proxy["Proxy"].value)(v2.value0)) + "\"]"))(v.element)();
                                                        return for_2(itemDiv)(function (item) {
                                                            return function __do() {
                                                                Utils_DOM.show(item)();
                                                                var deliveryCost = Utils_DOM["querySelector$prime"](".js-delivery-details__delivery-cost")(item)();
                                                                return for_2(getField1(Type_Proxy["Proxy"].value)(v2.value0))(function (info) {
                                                                    return function __do() {
                                                                        for_2(deliveryCost)(Utils_DOM.setInnerText(Restaumatic_Site_I18n.currency(getField2(Type_Proxy["Proxy"].value)(info))))();
                                                                        var minOrderValue = Utils_DOM["querySelector$prime"](".js-delivery-details__min-order-value")(item)();
                                                                        for_2(minOrderValue)(Utils_DOM.setInnerText(Restaumatic_Site_I18n.currency(getField3(Type_Proxy["Proxy"].value)(info))))();
                                                                        var origin$prime = bindFlipped(Web_HTML_Location.origin)(bindFlipped(Web_HTML_Window.location)(Web_HTML.window))();
                                                                        var m_path = map(function (s) {
                                                                            return origin$prime + ("/restauracja/" + s);
                                                                        })(getField4(Type_Proxy["Proxy"].value)(v2.value0));
                                                                        var link = Utils_DOM["querySelector$prime"](".js-delivery-details__button")(item)();
                                                                        for_2(m_path)((function () {
                                                                            var $136 = for_2(link);
                                                                            var $137 = Web_DOM_Element.setAttribute("href");
                                                                            return function ($138) {
                                                                                return $136($137($138));
                                                                            };
                                                                        })())();
                                                                        var freeThreshold = Utils_DOM["querySelector$prime"](".js-delivery-details__free-threshold")(item)();
                                                                        return for_2(freeThreshold)(function (threshold) {
                                                                            return function __do() {
                                                                                var freeThresholdParent = Utils_DOM["parentNode$prime"](Web_DOM_Element.toNode(threshold))();
                                                                                var v3 = getField5(Type_Proxy["Proxy"].value)(info);
                                                                                if (v3 instanceof Data_Maybe.Nothing) {
                                                                                    return Utils_DOM.hide(freeThresholdParent)();
                                                                                };
                                                                                if (v3 instanceof Data_Maybe.Just) {
                                                                                    Utils_DOM.show(freeThresholdParent)();
                                                                                    return Utils_DOM.setInnerText(Restaumatic_Site_I18n.currency(v3.value0))(threshold)();
                                                                                };
                                                                                throw new Error("Failed pattern match at Components.DeliveryForm (line 129, column 21 - line 134, column 67): " + [ v3.constructor.name ]);
                                                                            };
                                                                        })();
                                                                    };
                                                                })();
                                                            };
                                                        })();
                                                    };
                                                    if (v2 instanceof Data_Maybe.Nothing) {
                                                        return Data_Unit.unit;
                                                    };
                                                    throw new Error("Failed pattern match at Components.DeliveryForm (line 106, column 11 - line 135, column 33): " + [ v2.constructor.name ]);
                                                };
                                                return Data_Unit.unit;
                                            };
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    }))();
    return Utils_DOM.show(form)();
};
var headE = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var bind3 = Control_Bind.bind(Monad0.Bind1());
    var foldDyn = Specular_FRP_Base.foldDyn(dictMonadFRP);
    var pure3 = Control_Applicative.pure(Monad0.Applicative0());
    return function (e) {
        return bind3(foldDyn(function (v) {
            return function (n) {
                return add(n)(1);
            };
        })(0)(e))(function (occurences) {
            return pure3(Specular_FRP_Base.filterMapEvent(function (v) {
                var $127 = v.value0 === 1;
                if ($127) {
                    return new Data_Maybe.Just(v.value1);
                };
                return Data_Maybe.Nothing.value;
            })(Specular_FRP_Base.attachDynWith(Data_Tuple.Tuple.create)(occurences)(e)));
        });
    };
};
export {
    UNKNOWN,
    OK,
    OTHER,
    init,
    headE,
    parseAccountId
};
